import styled from "styled-components";
import { BreakPoints, FontWeights } from "../../constants"
import { typographyMixin } from "../../typography";

export const StyledLeadersContainer = styled.div`
  width: 100%;
  padding: 1rem 0 0 0;
  ${typographyMixin}
  .title-divider {
    font-weight: ${FontWeights.bold};
    padding: 0 0 0 0.5rem;
    @media only screen and (max-width: ${BreakPoints.sm}) {
      padding: 0 0rem;
    }
  }

  @media only screen and (max-width: ${BreakPoints.sm}) {
    padding: 1rem 0 0 0;
  }
`;

export const StyledStatLeaders = styled.div`
  padding: 1rem 0 0.5rem 0.5rem;
  .title-bar1{
    background-color: ${(props) => props.theme.secondaryColor};
    color: ${(props) => props.theme.textOnSecondaryColor};
  }
  @media only screen and (max-width: ${BreakPoints.sm}) {
    padding: 1rem 0rem;
  }
`;

export const StyledLeader = styled.div<{ enableLinks: boolean }>`
  min-height: 60px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  cursor: ${(props) => (props.enableLinks ? "pointer" : "default")};

  &:nth-child(odd) {
    background-color: rgba(55, 56, 61, 0.05);
  }

  &:hover {
    background: ${(props) => props.enableLinks && "rgba(55, 56, 61, 0.2)"};
  }

  .player-team-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  .avatar {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 60px;
    @media only screen and (max-width: ${BreakPoints.sm}) {
      /* TODO: Mobile small view avatars should disapear
      display: none; */
    }
  }

  .player {
    font-size: 18px;
    padding-bottom: 0.25rem;
    text-transform: uppercase;
    @media only screen and (max-width: ${BreakPoints.sm}) {
      font-size: 14px;
    }
  }
  .team {
    font-size: 16px;
    opacity: 0.45;
    font-size: 0.875rem;
    font-weight: ${FontWeights.regular};
    @media only screen and (max-width: ${BreakPoints.sm}) {
      font-size: 12px;
    }
  }
  .stat {
    font-size: 24px;
    font-weight: ${FontWeights.bold};
    min-width: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    @media only screen and (max-width: ${BreakPoints.sm}) {
      font-size: 14px;
    }
  }
`;

export const Avatar = styled.img`
  object-fit: contain;
  max-width: 56px;
  max-height: 56px;
`;